import { useTranslation } from 'react-i18next';
import { TableCell } from '@mui/material';
import Logo from '@shared/assets/Logo';
import { icons } from '@shared/static/icons';
import { CountryFlag } from '@shared/ui/parts';
import { getCryptoName } from '@utils/balance-helpers';
import { binsLogo } from '@utils/static';

export function BalanceBankContent({ row, isFrom }) {
  const { t } = useTranslation();
  const bank = isFrom ? row.bank_from : row.bank_to;
  const name =
    isFrom && row.is_crypto
      ? getCryptoName(row.currency_from)
      : bank?.public_name;
  const bankLogo = binsLogo[bank?.id];

  return (
    <div className={`balanceBankCell ${name ? '' : 'show-logo'}`}>
      {name && icons[name]}
      {bankLogo && <CountryFlag countryCode={bankLogo} />}
      {!name && <Logo />}
      <div>
        {name === 'Master balance' ? (
          <>
            <span className="fw-500">{t('Master')}</span>
            <br />
            <span className="secondary-text">{t('balance')}</span>
          </>
        ) : (
          name && <span className="fw-500">{name}</span>
        )}
      </div>
      {isFrom && (
        <div className="balanceBankCell__chevron">{icons['chevron-right']}</div>
      )}
    </div>
  );
}

export default function BalanceBankCell({ row, isFrom = false }) {
  return (
    <TableCell>
      <BalanceBankContent row={row} isFrom={isFrom} />
    </TableCell>
  );
}
